import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  typeTab: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

export default useStyles;
